import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { AdminAlternativeBookingPageComponent } from './admin-alternative-booking.page';

const routes: Routes = [
  {
    path: '',
    component: AdminAlternativeBookingPageComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AdminAlternativeBookingPageRoutingModule {}
